import ProductCard from '../components/ProductCard/ProductCard';

const App = () => <ProductCard />;
export default App;
